import React from "react";
import { Label } from "reactstrap";
import { Portuguese } from "flatpickr/dist/l10n/pt";
import { Format } from "utils";

import "@styles/react/libs/flatpickr/flatpickr.scss";
import "flatpickr/dist/plugins/monthSelect/style.css";

import { Controller } from "react-hook-form";
import { registerLocale } from "react-datepicker";

import { useSkin } from "@hooks/useSkin";

import ptBR from "date-fns/locale/pt-BR";

import * as S from "./styles";

registerLocale("ptBR", ptBR);

export const DatePickerRange = ({
  control,
  name,
  label,
  placeholder,
  ...rest
}) => {
  const { skin } = useSkin();

  if (control) {
    return (
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => (
          <>
            <Label>{label}</Label>
            <S.CustomFlatpickr
              options={{
                disableMobile: true,
                locale: Portuguese,
                format: "Y-m-d",
                mode: "range",
                formatDate: valueDate => {
                  if (
                    valueDate instanceof Date &&
                    !isNaN(valueDate.getTime())
                  ) {
                    return Format(valueDate, "dd/MM/yyyy");
                  }
                  return "";
                },
              }}
              className="form-control text-primary"
              value={value}
              onChange={onChange}
              placeholder={placeholder}
              skin={skin}
            />
          </>
        )}
      />
    );
  }

  return (
    <>
      <Label>{label}</Label>
      <S.CustomFlatpickr
        options={{
          locale: Portuguese,
          dateFormat: "Y-m-d",
          mode: "range",
          formatDate: valueDate => {
            return valueDate > 0
              ? Format(valueDate, "dd/MM/yyyy")
              : "Carregando data...";
          },
        }}
        {...rest}
        className="form-control"
        placeholder={placeholder}
        skin={skin}
      />
    </>
  );
};

export const DatePicker = ({
  control,
  name,
  label,
  placeholder,
  type = "default" || "range",
  required = false,
  configs,
  error,
  helperText,
  disabled = false,
  ...props
}) => {
  const { skin } = useSkin();

  const configOptions = {
    disableMobile: configs?.disableMobile || true,
    locale: Portuguese,
    format: configs?.format || "Y-m-d",
    ...configs,
  };
  if (type === "range") {
    return (
      <DatePickerRange
        control={control}
        name={name}
        label={label}
        placeholder={placeholder}
        skin={skin}
      />
    );
  }

  return (
    <Controller
      rules={{ required }}
      required={required}
      control={control}
      name={name}
      helperText={helperText}
      render={({ field: { onChange, value } }) => (
        <>
          <Label>
            {label}
            {label && required ? "*" : null}
          </Label>
          <S.CustomFlatpickr
            disabled={disabled}
            options={configOptions}
            className="form-control text-primary"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            error={!value && error}
            {...props}
            skin={skin}
          />
          <S.InputFieldHelperText error={!value && error}>
            {helperText}
          </S.InputFieldHelperText>
        </>
      )}
    />
  );
};
